<template>
  <div class="tradeModel">
    <div class="layout">
      <div class="money">
        <ul>
          <li><p>交易总手数</p><span v-if="entrust.total">{{ parseFloat(entrust.total.tradeVolume).toFixed(2) }}手</span></li>
        </ul>
      </div>
      <div class="reportTit">
        <p>共计{{ entrust.totalSize }}条记录</p>
        <span @click="selectBrush">筛选<img src="@/assets/images/template/SX.png"></span>
      </div>
    </div>
    <div v-if="entrust.recordList" class="reportList">
      <ul v-if="entrust.recordList.length>0">
        <li v-for="item in entrust.recordList" @click="selectEntrustPro(item)">
          <div class="item">
            <span>{{ item.name }}<em>#{{ item.orderid }}</em></span>
            <em>{{ timeZone(item.requesttime) }}</em>
          </div>
          <div class="item">
            <div class="itemCon">
              <div class="flexStart">
                <div class="itemWidth"><p class="p_mode" :class="classType(item.direction)">{{ item.direction }}{{ item.direction=="买"?"入":'出' }}</p><p>{{ item.requestvolume }}手</p></div>
                <div class="itemWidth"><p class="color">{{ item.kind }}价</p><p>{{ item.requestpriceStr }}</p></div>
              </div>
              <div class="flexStart"><p>{{ item.expiretype }}</p></div>
            </div>
            <div class="flexEnd"><p v-if="item.execpriceStr!=''" class="size" :class="classType(item.execpriceStr)">{{ item.execpriceStr }}</p></div>
          </div>
        </li>
      </ul>
      <noData v-else />
    </div>
    <!--委托详情-->
    <div v-if="isShowEntrust" class="popFixed">
      <div class="masking" @click="closeEntrustPop" />
      <div class="tcCon">
        <div class="holdBank between">
          <div class="item">
            <span>交易详情</span>
            <ul>
              <li><span>挂单时间</span><span>{{ timeZone(requesttime) }}</span></li>
              <li><span>挂单号</span><span>{{ orderid?"#":'' }}{{ orderid }}</span></li>
              <li><span>产品</span><span>{{ name }}</span></li>
              <li><span>类型</span><span>{{ type }}</span></li>
              <li><span>类别</span><span>{{ kind }}</span></li>
              <li><span>方向</span><span>{{ direction }}</span></li>
              <li><span>手数</span><span>{{ requestvolume }}</span></li>
              <li><span>成交价</span><span>{{ execpriceStr }}</span></li>
              <li><span>挂单价</span><span>{{ requestpriceStr }}</span></li>
              <li v-if="takeprofitStr!=''"><span>止盈</span><span>{{ takeprofitStr }}</span></li>
              <li v-if="stoplossStr!=''"><span>止损</span><span>{{ stoplossStr }}</span></li>
              <li><span>状态</span><span>{{ status }}</span></li>
              <li><span>期限</span><span>{{ expiretype }}</span></li>
              <li><span>成交号</span><span>{{ dealid?"#":'' }}{{ dealid }}</span></li>
              <li><span>成交时间</span><span>{{ timeZone(exectime) }}</span></li>
            </ul>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="closeEntrustPop">知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noData from '@/view/module/noData.vue'
import utils from '@/utils/tradeDataUtil'
export default {
  name: 'EntrustRecord',
  components: { noData },
  props: ['entrust', 'isBrushTradePop'],
  data() {
    return {
      isShowEntrust: false,
      requesttime: '',
      orderid: '',
      name: '',
      type: '',
      kind: '',
      direction: '',
      requestvolume: '',
      execpriceStr: '',
      requestpriceStr: '',
      takeprofitStr: '',
      stoplossStr: '',
      status: '',
      expiretype: '',
      dealid: '',
      exectime: '',
      scrollHeight: '',
      pattern: this.$route.query.pattern || '',
      timeZones: this.$route.query.timeZones || ('GMT+8')
    }
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    removeStyle() {
      const main = document.getElementById('main')
      main.removeAttribute('style')
      window.scrollTo(0, this.scrollHeight)
    },
    addStyle() {
      const main = document.getElementById('main')
      let top, body, css
      if (document.documentElement) {
        body = document.documentElement
      } else if (document.body) {
        body = document.body
      }
      if (body.scrollTop) {
        top = body.scrollTop
      } else if (window.pageYOffset) {
        top = window.pageYOffset
      }
      css = 'width: 100%; height: 100%; position: fixed; top: -' + top + 'px;left: 0;'
      main.style.cssText = css
      this.scrollHeight = top
    },
    timeZone(val) {
      if (!val) return ''
      if (val) {
        const localTime = utils.getLocalTime(Number(this.timeZones.substr(3)), val)
        return new Date(localTime).format('Y-MM-dd hh:mm:ss')
      }
    },
    closeEntrustPop() {
      this.removeStyle()
      this.isShowEntrust = false
    },
    selectEntrustPro(data) {
      this.addStyle()
      this.isShowEntrust = !this.isShowEntrust
      this.requesttime = data.requesttime
      this.orderid = data.orderid
      this.name = data.name
      this.type = data.type
      this.kind = data.kind
      this.direction = data.direction
      this.requestvolume = data.requestvolume
      this.execpriceStr = data.execpriceStr
      this.requestpriceStr = data.requestpriceStr
      this.takeprofitStr = data.takeprofitStr
      this.stoplossStr = data.stoplossStr
      this.status = data.status
      this.expiretype = data.expiretype
      this.dealid = data.dealid
      this.exectime = data.exectime
    },
    selectBrush() {
      this.toggleFixed()
      let isShowTradeType = this.isBrushTradePop
      isShowTradeType = !isShowTradeType
      this.$emit('blushPop', isShowTradeType)
    },
    classType(obj) {
      let val
      if (this.pattern) {
        if (this.pattern == 'redGreen') {
          if (obj > 0) val = 'fall'
          else if (obj < 0) val = 'rise'
          else if (obj == 0) val = ''
          else if (obj == '买') val = 'buy'
          else if (obj == '卖') val = 'sell'
        } else if (this.pattern == 'greenRed') {
          if (obj > 0) val = 'rise'
          else if (obj < 0) val = 'fall'
          else if (obj == 0) val = ''
          else if (obj == '买') val = 'sell'
          else if (obj == '卖') val = 'buy'
        }
      } else {
        if (obj > 0) val = 'rise'
        else if (obj < 0) val = 'fall'
        else if (obj == 0) val = ''
        else if (obj == '买') val = 'sell'
        else if (obj == '卖') val = 'buy'
      }
      return val
    }
  }
}
</script>
